import type { RouteObject } from 'react-router';
import { PromotionsPage } from './pages/PromotionsPage';

export const promotionRoutes: RouteObject[] = [{ path: 'promotions', element: <PromotionsPage /> }];
